import Vue from 'vue'
import Vuex from 'vuex'

import store from './store.js'
import services from "../services"
import constants from "../services/constants"
import LazyLoad from "./directives/LazyLoad"
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: google_tag_manager_id,
  dataLayer: window.dataLayer // pass the dataLayer object to vue-analytics
});

window.dataLayer = window.dataLayer || [];

window._ = require('lodash')

try {
    window.Popper = require('popper.js').default
    window.services = services
    window.$ = window.jQuery = require('jquery')

    require('bootstrap')
} catch (e) {}

window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

Vue.use(Vuex)

Vue.directive("lazyLoad", LazyLoad);

const files = require.context('./components', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.mixin({
    methods: services,
    data: function () {
        return {
            constants: constants,
            _configs: _configs,
        }
    }
})

window.Vue = Vue
window.Vuex = Vuex

const vueApp = new Vue({
    el: '#front',
    store: new Vuex.Store(store)
});
window.vueApp = vueApp

$(document).ready(function() {
    $( 'body #accordionPayment .cc-number' ).payment( 'formatCardNumber' );
    $( 'body #accordionPayment .cc-expiry' ).payment( 'formatCardExpiry' );
    $( 'body #accordionPayment .cc-cvc' ).payment( 'formatCardCVC' );

    const images = document.querySelectorAll('.data_fancy_box_fix img:not(.not-fancy)');
    images.forEach(image => {
        if (!image.getAttribute('data-fancybox')) {
            image.setAttribute('data-fancybox','');
        }
    });

    // $('body').on('click','.shipping-calculator-button',function()
    // {
    //     $(this).siblings('.shipping_box').fadeToggle('slow');
    // });

    $('.data_fancy_box_fix img[data-fancybox]').each(function() {
        $(this).addClass('abc');
        var $img = $(this);
        var thumbSrc = $img.attr('src');
        var imgAlt = $img.attr('alt');

        var fullSrc = thumbSrc.replace(/-\d+x\d+\./, '.');
        if (fullSrc !== thumbSrc) {
          $img.wrap($('<a>', {
            href: fullSrc,
            class: 'fancybox'
          }));
          $img.attr('data-src', fullSrc);
        }

        if($img.parents('.init-flickity[data-main="carousel-product-nav"]').length)
        {
            $img.attr('data-caption', imgAlt);
        }

        if($img.parents('#single-carousel[data-main="carousel-product-nav"]').length)
        {
            $img.attr('data-caption', imgAlt);
        }
      });

    $('img[data-fancybox]').each(function() {
        var $img = $(this);
        var thumbSrc = $img.attr('src');
        var fullSrc = thumbSrc.replace(/-\d+x\d+\./, '.');
        $img.attr('data-src', fullSrc);
    });

    // check if quantity id exists
    if ($('#quantity').length > 0) {
        // Add event listener to format the input value on keyup
        document.getElementById("quantity").addEventListener("keyup", function (e) {

            // Remove any non-numeric characters from the input value
            const numericValue = this.value.replace(/[^0-9]/g, "");

            // Add thousand separators to the numeric value
            const formattedValue = Number(numericValue).toLocaleString();

            // Update the input field's data-display attribute with the formatted value
            this.setAttribute("data-display", formattedValue);
        });

        window.addEventListener('load', function() {
            sessionStorage.removeItem('codeExecuted');
        });
    }
    // add class if description is empty
    if( $('.top-description').is(':empty') ) {
        $('.top-description').addClass("empty-description");
    }

    function addClassOnThirdText() {
        var i = 0;
        $('.tab-pane').each(function(index) {
            var k = 0;
            $(this).find('.ezcol-sixth').each(function(j) {
                $(this).addClass(j+'index');
                if ((j + 1) % 3 === 0) {
                    $(this).addClass('third-child');
                }
               k++;
            });
            i++;
        });
    }

    function addClassOnSecondChild() {
        // $('.tab-pane .ezcol-sixth').each(function(index) {
        //     if ((index + 1) % 2 === 0) {
        //         $(this).addClass('second-child');
        //     }
        // });

        var i = 0;
        $('.tab-pane').each(function(index) {
            var k = 0;
            $(this).find('.ezcol-sixth').each(function(j) {
                $(this).addClass(j+'index');
                if ((j + 1) % 2 === 0) {
                    $(this).addClass('second-child');
                }
               k++;
            });
            i++;
        });

    }
        // Initial check on page load
        if (window.innerWidth >= 567 && window.innerWidth <= 767) {
            addClassOnThirdText();
        } else if (window.innerWidth >= 340 && window.innerWidth <= 565) {
            addClassOnSecondChild();
        }
        // Check screen size on window resize
        $(window).resize(function() {
            if (window.innerWidth >= 567 && window.innerWidth <= 767) {
                $('.tab-pane .ezcol-sixth').removeClass('third-child');
                addClassOnThirdText();
            } else if (window.innerWidth >= 340 && window.innerWidth <= 565) {
                $('.tab-pane .ezcol-sixth').removeClass('second-child');
                addClassOnSecondChild();
            } else {
                $('.tab-pane .ezcol-sixth').removeClass('third-child second-child');
            }
        });

});

$('body').on('click', 'a[href*=\\.pdf]', function (e) {
    // if(!( /Android|Safari|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) || (window.matchMedia('(min-width: 992px)').matches)) {
        e.preventDefault();
        const pdfUrl = $(this).attr('href');
        if (pdfUrl) {
            //    $('body #pdfModal .modal-content').html(`<iframe id="fred" style="border:1px solid #666CCC" title="PDF in an i-Frame" src="${pdfUrl}" frameborder="1" scrolling="auto" height="1100" width="850" ></iframe>`)
            //    $('body #pdfModal').modal('show')

            window.open(
            pdfUrl,
            '_blank' // <- This is what makes it open in a new window.
            );
        }
    // }
})


document.addEventListener('DOMContentLoaded', (event) => {
    const textarea = document.getElementById('textarea_word_count');
    const charCount = document.getElementById('charCount');
    if(textarea)
    {
        const currentLengthPer = textarea.value.length;
        textarea.addEventListener('input', () => {
            const currentLength = textarea.value.length;
            charCount.textContent = `Character Count: ${currentLength}/1024`;
        });
    }
    
});
